/*
 * @Author: edvardchen
 * @Date: 2017-12-25 17:41:45
 * @Last Modified by: edvardchen
 * @Last Modified time: 2018-01-17 18:09:08
 */

// @flow
import React from 'react';
import Icon from 'uistyles/comby/icon';
import bem from 'uistyles/comby/_libs/utils/bem';

import autobind from 'core-decorators/lib/autobind';
import classnames from 'classnames';

import { shortString } from '../../../utility';

type Props = {
  onClick: Function,
  praised: boolean,
  praiseNum: number,
  newStyle?: boolean,
};

type S = {
  animated: boolean,
};

class Praise extends React.PureComponent<Props, S> {
  state = { animated: false };

  @autobind
  onPraise(event: Event) {
    event.stopPropagation();
    const { praised } = this.props;
    if (praised) {
      return;
    }
    this.setState({
      animated: true,
    });
    const { onClick: onPraise } = this.props;
    onPraise && onPraise();
  }

  render() {
    const { praised, praiseNum, newStyle } = this.props;
    const { animated } = this.state;
    const icon = <Icon isAuto type={praised ? 'hot' : ''} icon={praised ? 'thumbs-up-o' : 'thumbs-up'} />;
    const value = praiseNum > 0 ? shortString(praiseNum) : ' ';
    const displayName = 'priaise';
    return (
      <span
        className={classnames('cb-iconbtn', bem(displayName), {
          'is-animation': animated,
          'new-style': newStyle,
        })}
        onClick={this.onPraise}
      >
        {value && <span className={bem(displayName, 'num')}> {value}</span>}
        {icon}
        <span className="prise-star" />
      </span>
    );
  }
}

export default Praise;
